// react-query provider — client-side singleton client.
"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import * as React from "react";

import getQueryClient from "./getQueryClient";

export default function QueryProvider({ children }: { children: React.ReactNode }) {
  // Use a state to ensure queryClient is created only once per component lifecycle
  const [queryClient] = React.useState(() => getQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === "development" ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
}
